import React from "react";
import { NavLink } from "react-router";

export type ErrorPageProps = {
  errorCode?: string;
  title: string;
  description: string;
  icon: string;
  iconColor?: string;
  primaryAction?: {
    label: string;
    href?: string;
    onClick?: () => void;
  };
  secondaryAction?: {
    label: string;
    href?: string;
    onClick?: () => void;
  };
  additionalInfo?: React.ReactNode;
  showContactInfo?: boolean;
};

export default function ErrorPageTemplate({
  errorCode,
  title,
  description,
  icon,
  iconColor = "#6c757d",
  primaryAction,
  secondaryAction,
  additionalInfo,
  showContactInfo = true,
}: ErrorPageProps) {
  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card shadow-sm border-0">
            <div className="card-body text-center py-5">
              {/* Error Code */}
              {errorCode && (
                <div className="error-number mb-4">
                  <h1
                    className="display-1 fw-bold mb-0"
                    style={{
                      fontSize: "8rem",
                      color: iconColor,
                      textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    {errorCode}
                  </h1>
                </div>
              )}

              {/* Icon */}
              <div className="mb-4">
                <i
                  className={`ti ${icon}`}
                  style={{
                    fontSize: errorCode ? "4rem" : "6rem",
                    color: iconColor,
                  }}
                ></i>
              </div>

              {/* Title and Description */}
              <h2 className="h4 text-dark mb-3">{title}</h2>
              <p className="text-muted mb-4 px-3">{description}</p>

              {/* Action Buttons */}
              {(primaryAction || secondaryAction) && (
                <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center mb-4">
                  {primaryAction && (
                    <>
                      {primaryAction.href ? (
                        <NavLink
                          to={primaryAction.href}
                          className="btn btn-primary px-4"
                          style={{
                            backgroundColor: "#ED0F7E",
                            borderColor: "#ED0F7E",
                          }}
                        >
                          {primaryAction.label}
                        </NavLink>
                      ) : (
                        <button
                          className="btn btn-primary px-4"
                          onClick={primaryAction.onClick}
                          style={{
                            backgroundColor: "#ED0F7E",
                            borderColor: "#ED0F7E",
                          }}
                        >
                          {primaryAction.label}
                        </button>
                      )}
                    </>
                  )}

                  {secondaryAction && (
                    <>
                      {secondaryAction.href ? (
                        <NavLink
                          to={secondaryAction.href}
                          className="btn btn-outline-secondary px-4"
                        >
                          {secondaryAction.label}
                        </NavLink>
                      ) : (
                        <button
                          className="btn btn-outline-secondary px-4"
                          onClick={secondaryAction.onClick}
                        >
                          {secondaryAction.label}
                        </button>
                      )}
                    </>
                  )}
                </div>
              )}

              {/* Additional Information */}
              {additionalInfo && (
                <div className="mt-4 pt-4 border-top">{additionalInfo}</div>
              )}

              {/* Contact Information */}
              {showContactInfo && (
                <div className="mt-5 pt-4 border-top">
                  <p className="text-muted small mb-3">
                    Precisa de ajuda? Entre em contacto connosco:
                  </p>
                  <div className="d-flex justify-content-center gap-3">
                    <a
                      href="mailto:support@maputobikestyle.com"
                      className="text-decoration-none"
                    >
                      <i className="ti ti-mail text-muted"></i>
                      <span className="ms-1 text-muted">Email</span>
                    </a>
                    <a
                      href="tel:+258123456789"
                      className="text-decoration-none"
                    >
                      <i className="ti ti-phone text-muted"></i>
                      <span className="ms-1 text-muted">Telefone</span>
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
